import Vue from 'vue';
import VueSweetalert2 from 'vue-sweetalert2';

Vue.use(VueSweetalert2);

/**
 * Creates a confirmation dialog using SweetAlert2
 * @param {string} message - The message to display in the dialog
 * @param {Object} options - Additional options for the dialog
 * @param {string} [options.confirmButtonText='OK'] - Text for confirm button
 * @param {string} [options.cancelButtonText='Cancel'] - Text for cancel button
 * @param {string} [options.type='warning'] - Alert type (warning, success, error, etc)
 * @returns {Promise} Promise that resolves when dialog is closed
 *
 * @example
 * // Basic usage
 * this.$confirm('Are you sure?')
 *
 * @example
 * // With custom options
 * this.$confirm('Delete item?', {
 *   confirmButtonText: 'Delete',
 *   type: 'error'
 * })
 */
Vue.prototype.$confirm = (message, options = {}) => {
  return Vue.swal({
    title: message,
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: options.confirmButtonText || 'OK',
    cancelButtonText: options.cancelButtonText || 'Cancel',
    type: options.type || 'warning',
    customClass: {
      confirmButton: 'btn btn-primary',
      cancelButton: 'btn btn-outline-danger ml-1'
    },
    buttonsStyling: false,
    ...options
  });
};
